module.exports = __webpack_public_path__ + "static/img/phone-CL.d83111f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-CL.png
// module id = +cXk
// module chunks = 1